<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <RadioGroup :inputValue="formInline.ischeck" :options="radioData" @radioChange="radioChange" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :showTotal="true" :getTotal="getTotal" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

let fromPath = null

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'cap',
      getListUrl: 'reclist',
      breadcrumb: [
        { name: "财务管理", path: `/finance/accounts` },
        { name: "合同账款管理", path: `/finance/accounts` },
        { name: "车辆列表" },
      ],
      wxtsList: [
        {
          name: '应收运费=运费总额-亏吨金额+运单补差'
        },
        {
          name: '应付运费=承运运费-亏吨金额'
        }
      ],
      radioData: [
        { label: "自有车辆", value: 1 },
        { label: "外协车辆", value: 2 },
      ],
      formInline: {
        ischeck: 2
      },
      formCtrl: [
        { ...this.ctrls.license },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "承运运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ys_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "yf_freight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      btns: [
        {
          title: '运单列表',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ license }) => {
            let path = `/finance/AccountPayOrder`
            if (this.$route.path.includes('/contract/statistics')) {
              path = `/contract/payOrder`
            }
            const { contractid } = this.formInline
            this.$router.push({
              path,
              query: {
                license,
                contractid,
              }
            });
          },
        },
      ],
      getTotalProperty: [
        'caton',
        'inton',
        'unton',
        'kuiton',
        'kuitotal',
        'freight',
        'infreight',
        'compen',
        'ys_freight',
        'yf_freight',
      ],
      baseParams: ['contractid', 'ischeck'],
    };
  },
  methods: {
    radioChange(v) {
      console.log(v)
      let path = `/finance/carlist`
      if (v != 1 && this.$route.path.includes('contract')) {
        path = `/contract/statistics2`
      } else if (v == 1 && this.$route.path.includes('contract')) {
        path = `/contract/statistics`
      } else if (v != 1) {
        path = `/finance/hirecarlist`
      }
      const query = this.$route.query
      // console.log(path)
      this.$router.push({
        path,
        query,
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    fromPath = from.path
    // console.log(fromPath)
    next()
  },
  mounted() {
    const { id } = this.$route.query
    this.formInline = {
      contractid: id,
      ischeck: 2,
    }
    this.$nextTick(this.getList)
    if (this.$route.path.includes('contract')) {
      this.breadcrumb = [
        { name: "合同管理", path: `/contract/list` },
        { name: "合同列表", path: `/contract/list` },
        { name: "合同统计" },
      ]
      if (fromPath) {
        this.breadcrumb[1].path = fromPath
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
